import { Button } from '@bp/ui-components';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { BpSubpage } from '../../components/BpSubpage/BpSubpage';
import { AboutModal } from '../../components/Modals/AboutModal/AboutModal';
import { PageLayoutPlaceholder } from '../../components/PageLayoutPlaceholder/PageLayoutPlaceholder';

export const LoginPage: FC = () => {
  const { t } = useTranslation();
  const auth = useAuth();

  const [showAbout, setShowAbout] = useState<boolean>(false);

  const login = async () => {
    await auth.signinRedirect();
  };

  return (
    <BpSubpage>
      <PageLayoutPlaceholder>
        <Button hierarchy='primary' onClick={() => login()} fullWidth className='mt-4'>
          {t('auth.login')}
        </Button>
        <Button hierarchy='tertiary' onClick={() => setShowAbout(true)} fullWidth>
          {t('common.about')}
        </Button>
      </PageLayoutPlaceholder>
      <AboutModal state={showAbout} setState={(value) => setShowAbout(value)} />
    </BpSubpage>
  );
};
